import { apiFetch } from "@/lib/api";

import type { InventoryDiscrepancySkuContextRow } from "@/pages/manufacturing/inventoryDiscrepancyApi";

export type SkuTransactionHistoryRow = InventoryDiscrepancySkuContextRow & {
  location_code: string | null;
  covered_receipt_quantity?: number | null;
};

export type SkuTransactionHistoryOnHand = {
  location_id: number;
  on_hand: number;
};

export type SkuTransactionHistoryLocationBalance = {
  location_id: number;
  ledger: number;
  receiving: number;
  floor: number;
  shipped_open: number;
};

export type SkuTransactionHistoryResponse = {
  sku_id: string;
  rows: SkuTransactionHistoryRow[];
  anchor_on_hand: number | null;
  anchor_location_id: number | null;
  on_hand_by_location: SkuTransactionHistoryOnHand[];
  balances_by_location?: SkuTransactionHistoryLocationBalance[];
};

export async function fetchSkuTransactionHistory(
  sku: string,
  options?: { locationId?: number | null },
): Promise<SkuTransactionHistoryResponse> {
  const locationId = options?.locationId;
  return apiFetch<SkuTransactionHistoryResponse>("/api/mrp/skus/transaction-history", {
    query: {
      sku,
      ...(locationId != null && locationId > 0 ? { location_id: String(locationId) } : {}),
    },
  });
}
